var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,5c-3.85433,0 -7,3.14567 -7,7c0,2.44813 1.34416,4.50595 3.25781,5.75781c-3.65844,1.48827 -6.25781,5.05745 -6.25781,9.24219h2c0,-4.43067 3.56933,-8 8,-8c3.85433,0 7,-3.14567 7,-7c0,-3.85433 -3.14567,-7 -7,-7zM16,7c2.77367,0 5,2.22633 5,5c0,2.77367 -2.22633,5 -5,5c-2.77367,0 -5,-2.22633 -5,-5c0,-2.77367 2.22633,-5 5,-5zM24,18v2.20313c-0.61828,0.13133 -1.17545,0.35732 -1.6875,0.69531l-1.55664,-1.55469l-1.41211,1.41406l1.55469,1.55469c-0.33799,0.51205 -0.56399,1.06922 -0.69531,1.6875h-2.20312v2h2.20313c0.13133,0.61828 0.35732,1.17545 0.69531,1.6875l-1.55469,1.55469l1.41211,1.41406l1.55664,-1.55469c0.51205,0.33799 1.06922,0.56399 1.6875,0.69531v2.20313h2v-2.20312c0.61828,-0.13133 1.17545,-0.35732 1.6875,-0.69531l1.55664,1.55469l1.41211,-1.41406l-1.55469,-1.55469c0.33799,-0.51205 0.56399,-1.06922 0.69531,-1.6875h2.20313v-2h-2.20312c-0.13133,-0.61828 -0.35732,-1.17545 -0.69531,-1.6875l1.55469,-1.55469l-1.41211,-1.41406l-1.55664,1.55469c-0.51205,-0.33799 -1.06922,-0.56399 -1.6875,-0.69531v-2.20312zM25,22c1.66848,0 3,1.33152 3,3c0,1.66848 -1.33152,3 -3,3c-1.66848,0 -3,-1.33152 -3,-3c0,-1.66848 1.33152,-3 3,-3zM25,24c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/staff-icon.cb8e665a1dbfb006c78eb0268de3f45e.svg";
export { ForwardRef as ReactComponent };